<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Project/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>